import { render, staticRenderFns } from "./OcrResultDialog.vue?vue&type=template&id=71f01c5d&scoped=true&"
import script from "./OcrResultDialog.vue?vue&type=script&lang=ts&"
export * from "./OcrResultDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OcrResultDialog.vue?vue&type=style&index=0&id=71f01c5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f01c5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow,VSimpleTable,VSpacer})
